export interface WikiLinkContext {
  openOffset: number;
  query: string;
}

/** Find an unfinished [[wiki link]] immediately before the cursor. */
export function getWikiLinkContext(textBeforeCursor: string): WikiLinkContext | null {
  const match = /\[\[([^\[\]\n]*)$/.exec(textBeforeCursor);
  if (!match || match.index < 0) return null;
  return {
    openOffset: match.index,
    query: match[1] ?? "",
  };
}

export function filterWikiLinkTitles(
  titles: readonly string[],
  query: string,
  limit = 8,
): readonly string[] {
  const normalizedQuery = query.trim().toLocaleLowerCase();
  const unique = [...new Set(titles.map((title) => title.trim()).filter(Boolean))];
  return unique
    .filter((title) => title.toLocaleLowerCase().includes(normalizedQuery))
    .sort((first, second) => {
      const firstValue = first.toLocaleLowerCase();
      const secondValue = second.toLocaleLowerCase();
      const firstStarts = firstValue.startsWith(normalizedQuery);
      const secondStarts = secondValue.startsWith(normalizedQuery);
      if (firstStarts !== secondStarts) return firstStarts ? -1 : 1;
      return first.localeCompare(second);
    })
    .slice(0, limit);
}
